var _ellipse, _ellipse2, _ellipse3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVerticalDotMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 19,
    viewBox: "0 0 4 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.52197,
    ry: 1.52409,
    transform: "matrix(1 0 3.39804e-06 1 2.38721 1.69779)",
    fill: "#484848"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.52197,
    ry: 1.52409,
    transform: "matrix(1 0 3.39804e-06 1 2.37745 9.32084)",
    fill: "#484848"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.52197,
    ry: 1.52409,
    transform: "matrix(1 0 3.39804e-06 1 2.36768 16.9419)",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVerticalDotMenu);
export default __webpack_public_path__ + "static/media/icon_vertical_dot_menu.e2168c476ad35151957036e296406287.svg";
export { ForwardRef as ReactComponent };